import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { Uoms } from "../../uoms/uom.entity";
import { PalletCapacity } from "../pallet-capacity.entity";
import {  PalletCapacityDTO } from "./pallet-capacity.dto";

export class PalletCapacityAdapter {
    convertDtoToEntity(dtoObj: PalletCapacityDTO,  isUpdate: boolean = false ): PalletCapacity {
        try {
            console.log(dtoObj)
            const entityObj = new PalletCapacity();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.packingMethodInfo.packingMethodId = dtoObj.packingMethodId;
            entityObj.palletCapacity = dtoObj.palletCapacity;
            entityObj.sizeCategory = dtoObj.sizeCategory;
            entityObj.unitCodeInfo.unitcodeId= dtoObj.unitId;
            
            if (dtoObj.palletCapacityId) {
                entityObj.palletCapacityId = dtoObj.palletCapacityId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            return Error;
        }
    }

    public convertEntityToDto(entityObject: PalletCapacity): PalletCapacityDTO {
        const pallectCapacityDTO= new PalletCapacityDTO;
        pallectCapacityDTO.palletCapacityId = entityObject.palletCapacityId;
        pallectCapacityDTO.createdUser = entityObject.createdUser;
        pallectCapacityDTO.packingMethodId = entityObject.packingMethodInfo.packingMethodId;
        pallectCapacityDTO.palletCapacity = entityObject.palletCapacity;
        pallectCapacityDTO.unitId = entityObject.unitCodeInfo.unitcodeId;
        pallectCapacityDTO.sizeCategory = entityObject.sizeCategory;
        pallectCapacityDTO.isActive = entityObject.isActive;
        pallectCapacityDTO.createdAt = entityObject.createdAt;
        pallectCapacityDTO.updatedAt = entityObject.updatedAt;
        pallectCapacityDTO.createdUser = entityObject.createdUser;
        pallectCapacityDTO.updatedUser = entityObject.updatedUser;
        pallectCapacityDTO.versionFlag = entityObject.versionFlag;
        pallectCapacityDTO.palletCapacity=entityObject.palletCapacity;
        pallectCapacityDTO.packingMethod = entityObject.packingMethodInfo.packingMethodName;
        pallectCapacityDTO.unitName = entityObject.unitCodeInfo.unitcodeName;
        return pallectCapacityDTO;
      }
}